
<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>EW User Limit Config</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{name: 'Home'}">Home</router-link>
              </li>
              <li class="breadcrumb-item active">EW User Limit Config</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
        <div class="container-fluid">
          <div class="card" id="EWUserLimitConfig">
            <div class="overlay" v-if="is_loading">
              <i class="fas fa-2x fa-sync-alt fa-spin"></i>
            </div>
            <form @submit.prevent="handleSubmission()" method="POST" novalidate>
              <div class="card-header">
                <h3 class="card-title" v-if="!is_edit">Create</h3>
                <h3 class="card-title" v-if="is_edit">Edit</h3>
                <div class="card-tools">
                  <router-link class="btn btn-info" :to="{name: 'EWUserLimitConfigList'}"><i class="fas fa-list"></i> List
                  </router-link>
                </div>
              </div>
              <div class="card-body">
                <div class="row">
                    <div class="col-8">
                    
                    
            <div class="form-group required" >
              <label class="control-label">User</label>
              <input type="text" id="user_id" name="user_id"
                     v-bind:class="{'has-error' : errors.has('user_id')}"
                     v-validate="'required'"
                     v-model="value.user_id" class="form-control user_id"
                     placeholder="User">
              <div class="help text-danger" v-show="errors.has('user_id')">
                {{ errors.first("user_id") }}
              </div>
            </div>
            <div class="form-group required" >
              <label class="control-label">Transaction Activity Type</label>
              <input type="text" id="trx_activity_type_id" name="trx_activity_type_id"
                     v-bind:class="{'has-error' : errors.has('trx_activity_type_id')}"
                     v-validate="'required'"
                     v-model="value.trx_activity_type_id" class="form-control trx_activity_type_id"
                     placeholder="Transaction Activity Type">
              <div class="help text-danger" v-show="errors.has('trx_activity_type_id')">
                {{ errors.first("trx_activity_type_id") }}
              </div>
            </div>
            <div class="form-group required" >
              <label class="control-label">Minimum Amount Per Transaction</label>
              <input type="text" id="min_amount_per_trx" name="min_amount_per_trx"
                     v-bind:class="{'has-error' : errors.has('min_amount_per_trx')}"
                     v-validate="'required'"
                     v-model="value.min_amount_per_trx" class="form-control min_amount_per_trx"
                     placeholder="Minimum Amount Per Transaction">
              <div class="help text-danger" v-show="errors.has('min_amount_per_trx')">
                {{ errors.first("min_amount_per_trx") }}
              </div>
            </div>
            <div class="form-group required" >
              <label class="control-label">Maximum Amount Per Transaction</label>
              <input type="text" id="max_amount_per_trx" name="max_amount_per_trx"
                     v-bind:class="{'has-error' : errors.has('max_amount_per_trx')}"
                     v-validate="'required'"
                     v-model="value.max_amount_per_trx" class="form-control max_amount_per_trx"
                     placeholder="Maximum Amount Per Transaction">
              <div class="help text-danger" v-show="errors.has('max_amount_per_trx')">
                {{ errors.first("max_amount_per_trx") }}
              </div>
            </div>
            <div class="form-group required" >
              <label class="control-label">Daily Maximum Transaction</label>
              <input type="text" id="daily_max_trx_count" name="daily_max_trx_count"
                     v-bind:class="{'has-error' : errors.has('daily_max_trx_count')}"
                     v-validate="'required'"
                     v-model="value.daily_max_trx_count" class="form-control daily_max_trx_count"
                     placeholder="Daily Maximum Transaction">
              <div class="help text-danger" v-show="errors.has('daily_max_trx_count')">
                {{ errors.first("daily_max_trx_count") }}
              </div>
            </div>
            <div class="form-group required" >
              <label class="control-label">Daily Maximum Transaction Amount</label>
              <input type="text" id="daily_max_trx_amount" name="daily_max_trx_amount"
                     v-bind:class="{'has-error' : errors.has('daily_max_trx_amount')}"
                     v-validate="'required'"
                     v-model="value.daily_max_trx_amount" class="form-control daily_max_trx_amount"
                     placeholder="Daily Maximum Transaction Amount">
              <div class="help text-danger" v-show="errors.has('daily_max_trx_amount')">
                {{ errors.first("daily_max_trx_amount") }}
              </div>
            </div>
            <div class="form-group required" >
              <label class="control-label">Monthly Maximum Transaction</label>
              <input type="text" id="monthly_max_trx_count" name="monthly_max_trx_count"
                     v-bind:class="{'has-error' : errors.has('monthly_max_trx_count')}"
                     v-validate="'required'"
                     v-model="value.monthly_max_trx_count" class="form-control monthly_max_trx_count"
                     placeholder="Monthly Maximum Transaction">
              <div class="help text-danger" v-show="errors.has('monthly_max_trx_count')">
                {{ errors.first("monthly_max_trx_count") }}
              </div>
            </div>
            <div class="form-group required" >
              <label class="control-label">Monthly Maximum Transaction Amount</label>
              <input type="text" id="monthly_max_trx_amount" name="monthly_max_trx_amount"
                     v-bind:class="{'has-error' : errors.has('monthly_max_trx_amount')}"
                     v-validate="'required'"
                     v-model="value.monthly_max_trx_amount" class="form-control monthly_max_trx_amount"
                     placeholder="Monthly Maximum Transaction Amount">
              <div class="help text-danger" v-show="errors.has('monthly_max_trx_amount')">
                {{ errors.first("monthly_max_trx_amount") }}
              </div>
            </div>
                    </div>
                </div>
              </div>
              <div class="card-footer">
                <button type="submit" v-if="!is_edit" class="btn btn-primary">Submit</button>
                <button type="submit" v-if="is_edit" class="btn btn-primary">Update</button>
              </div>
            </form>
          </div>
        </div>
    </section>
  </div>
</template>

<script>

//import MasterLayout from "@/components/layouts/MasterLayoutComponent";
import {DepartmentsAPI, CommonAPI} from '@/services/api'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import axios from 'axios'

export default {
  name: 'EWUserLimitConfigForm',
  metaInfo: {
    title: 'EW User Limit Config | Dotlines'
  },
  components: {
    DatePicker
  },
  data: () => ({
    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    params: {},
    
    value: {
        
        
    },
    pre: {
      
    }
  }),
  methods: {
    
    
    
    handleSubmission () {
      let _this = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _this.is_loading = true
          let api_url = '/ew_user_limit_configs'
          let method = 'POST'
          if (_this.is_edit) {
            api_url = '/ew_user_limit_configs/' + _this.$route.params.id
            method = 'PUT'
          }
          
          axios({
            method: method,
            url: api_url,
            data: _this.value,
            headers: { 'Content-Type': 'application/json' },
          }).then(function (response) {
            _this.$toaster.success(response.data.message)
            _this.$router.push({'name': 'EWUserLimitConfigList'})
          }).catch((errors) => {
            if (errors.response.status === 500) {
              _this.$toaster.error(errors.response.data.message)
            }
            _this.$setErrorsFromResponse(errors.response.data)
          }).finally(() => {
            _this.is_loading = false
          });
        }
      });
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        let api_url = '/ew_user_limit_configs/' + id
        axios.get(api_url)
          .then(response => {
            resolve(response)
          })
          .catch((error) => {
            //console.log('error ' + error)
            reject(error)
          });
      });
    },
    async initialize () {
      this.is_loading = true
      this.params = this.$route.params
      
      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true
      }
      if (this.is_edit) {
        await this.getDetail(this.params.id).then(response => {
          this.value = response.data
        }).catch((error) => {
          console.log(error.response)
        })
        
        
      }
      
      this.is_loading = false
    }
  },
  mounted () {
    this.initialize()
  },
  /* created() {
    this.$emit("update:layout", MasterLayout);
  }, */
}
</script>

        